import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";
import AddIcon from "@mui/icons-material/Add";
import NewProgramStartModal from "@features/programs/modals/NewProgramStartModal";
import "./NewProgramFab.css";

/** Routes where a "new program" button would be noise or a trap. */
const HIDDEN_ON = ["/programs/create", "/login", "/register", "/permissions"];

/**
 * The always-available way into program creation, on desktop.
 *
 * Creating a program used to be reachable only from a patient's detail page,
 * which is the one place a therapist looking for "programs" in the menu never
 * ends up. The button follows them instead.
 *
 * Phones get the dashboard's own button rather than this one: a floating button
 * there competes with the fixed bottom bar and covers list content.
 */
export default function NewProgramFab() {
  const { t } = useTranslation();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:900px)");
  const [showModal, setShowModal] = useState(false);

  const hidden =
    isMobile || HIDDEN_ON.some((path) => location.pathname.startsWith(path));
  if (hidden) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className="new-program-fab"
        onClick={() => setShowModal(true)}
        title={t("programs.newProgramCta")}
        aria-label={t("programs.newProgramCta")}
      >
        <AddIcon fontSize="small" />
        <span className="new-program-fab-label">
          {t("programs.newProgramCta")}
        </span>
      </button>
      <NewProgramStartModal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </>
  );
}
